import Reveal from "../components/Reveal";
import QuoteForm from "../components/QuoteForm";
import SEO from "../components/SEO";
import { SITE } from "../data/content";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <main className="pt-28 pb-12" data-testid="contact-page">
      <SEO
        title="Contact Yellow | Video Production Liverpool | Get a Quote"
        description="Contact Yellow Video Production in Liverpool. Call 0151 427 2900 or email for a quote within 4 hours. Visit our studio at Columbus Quay, Liverpool L3 4DB."
        path="/contact"
        keywords="contact video production liverpool, video production company liverpool contact, yellow video production phone, video production liverpool quote"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Contact", path: "/contact" },
        ]}
      />
      <section className="yv-container">
        <Reveal>
          <p className="yv-eyebrow">Contact · Video Production Liverpool</p>
          <h1 className="yv-h1 mt-3 max-w-5xl">
            Let's make<br />
            <span style={{ color: "var(--yellow)" }}>something great.</span>
          </h1>
          <p className="text-white/70 max-w-2xl mt-5 text-lg leading-relaxed">
            Get in touch and we'll send a fixed-price quote within 4 working hours.
          </p>
        </Reveal>
      </section>

      <section className="yv-container mt-16 grid md:grid-cols-3 gap-6">
        <Reveal>
          <div className="p-8 bg-white/[0.03] border border-white/10 rounded-md h-full" data-testid="contact-call">
            <Phone className="text-[var(--yellow)]" size={28} />
            <h3 className="yv-h3 text-white mt-4">Call us</h3>
            <p className="text-white/65 text-sm mt-2">Any questions? Call the team right now and we'll answer any queries you have.</p>
            <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="text-[var(--yellow)] font-bold text-xl mt-4 inline-block hover:underline">
              {SITE.phone}
            </a>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="p-8 bg-white/[0.03] border border-white/10 rounded-md h-full" data-testid="contact-email">
            <Mail className="text-[var(--yellow)]" size={28} />
            <h3 className="yv-h3 text-white mt-4">Email us</h3>
            <p className="text-white/65 text-sm mt-2">Email a brief or questions to the address below and we'll get back to you within 3 working hours.</p>
            <a href={`mailto:${SITE.email}`} className="text-[var(--yellow)] font-bold mt-4 inline-block hover:underline break-all">
              {SITE.email}
            </a>
          </div>
        </Reveal>

        <Reveal delay={160}>
          <div className="p-8 bg-white/[0.03] border border-white/10 rounded-md h-full" data-testid="contact-visit">
            <MapPin className="text-[var(--yellow)]" size={28} />
            <h3 className="yv-h3 text-white mt-4">Visit us</h3>
            <p className="text-white/65 text-sm mt-2">Based in the City Centre, right on the River Mersey.</p>
            <p className="text-white/85 text-sm mt-4 font-semibold">{SITE.address1}</p>
          </div>
        </Reveal>
      </section>

      <section className="yv-container mt-16 grid lg:grid-cols-2 gap-12 items-start">
        <Reveal>
          <h2 className="yv-h2 text-white">Let us know your video requirements.</h2>
          <p className="text-white/65 leading-relaxed mt-4">
            Our new video production package includes:
          </p>
          <ul className="space-y-2 mt-5 text-white/80 text-sm">
            <li className="flex gap-2 before:content-['·'] before:text-[var(--yellow)]">Concept development, planning & scripting</li>
            <li className="flex gap-2 before:content-['·'] before:text-[var(--yellow)]">Filming with broadcast-quality kit</li>
            <li className="flex gap-2 before:content-['·'] before:text-[var(--yellow)]">Editing, motion graphics & music</li>
            <li className="flex gap-2 before:content-['·'] before:text-[var(--yellow)]">Multiple cut-downs for web, social & broadcast</li>
            <li className="flex gap-2 before:content-['·'] before:text-[var(--yellow)]">FREE stills photography worth £800</li>
            <li className="flex gap-2 before:content-['·'] before:text-[var(--yellow)]">Unlimited copyright usage</li>
          </ul>
          <p className="text-white/40 text-xs mt-8">
            We take data protection seriously. Your details will never be shared outside of Yellow.
          </p>
        </Reveal>
        <Reveal delay={120}>
          <QuoteForm heading="" />
        </Reveal>
      </section>

      <section className="yv-container mt-20">
        <div className="rounded-md overflow-hidden border border-white/10" data-testid="contact-map">
          <iframe
            title="Yellow Liverpool"
            src="https://www.google.com/maps?q=Columbus+Quay+Liverpool+L3+4DB&output=embed"
            className="w-full h-[380px] grayscale-[0.4] contrast-[1.1] brightness-[0.7]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>
    </main>
  );
}
